// extracted by mini-css-extract-plugin
export var button = "survey-success-module--button--rThr0";
export var happyEnd = "survey-success-module--happy-end--aRa4b";
export var imgWrapper = "survey-success-module--img-wrapper--nT-oo";
export var logo = "survey-success-module--logo---b7tL";
export var portrait = "survey-success-module--portrait--7kz5e";
export var success = "survey-success-module--success--J7ZH7";
export var surveyEnd = "survey-success-module--survey-end--7usFX";